import { UserProfile } from 'fitbeat.gym-core';
import { IOauthParams } from 'fitbeat.models';
import { showMessage } from '../../../ui/components/Toast';
import { openLink } from '../../../utils/linkUtils';
import ConnectedWorkoutApp, { AuthorizationStatus } from '../../../ConnectedApps/connected-workout-app';
import HealthConnectWrapper from '../../../ConnectedApps/HealthConnect/HealthConnectWrapper';

const HC_LINK = 'market://details?id=com.google.android.apps.healthdata&url=healthconnect%3A%2F%2Fonboarding';

interface IGarminAuthProps {
  garminAuth: IOauthParams;
  userProfile: UserProfile;
  settingUserGarminWorkoutImportConfig: (data: IOauthParams) => void;
  clearDeepLinks: (keys: string[]) => void;
}

export const handleConnectionToGarmin = async (props: IGarminAuthProps): Promise<void> => {
  const failedToConnectMessage = 'Failed to connect to Garmin Connect';

  try {
    props.settingUserGarminWorkoutImportConfig(props.garminAuth);
    props.clearDeepLinks(['garminAuth']);
  } catch (error) {
    showMessage(failedToConnectMessage);
  }
};

export const connectToApp = async (app: ConnectedWorkoutApp): Promise<'success' | 'error' | 'loading'> => {
  const { success, errorDisplayMessage, urlRedirect } = await app.requestAuthorization();

  if (!success) {
    showMessage(errorDisplayMessage);
    return 'error';
  }

  if (urlRedirect) {
    await openLink(urlRedirect);
    return 'loading';
  }

  const isAuthorized = await checkAuthStatus(app);
  if (isAuthorized) {
    return 'success';
  }

  return 'error';
};

export const checkAuthStatus = async (app: ConnectedWorkoutApp): Promise<boolean> => {
  const authStatus = await app.authorizationStatus();
  return authStatus === AuthorizationStatus.authorized;
};

export const handleHealthConnectInstallation = async (
  autoInstallApp: boolean,
): Promise<'success' | 'error' | 'loading'> => {
  const availability = await HealthConnectWrapper.getAvailability();
  if (availability === 'UpdateRequired' && autoInstallApp) {
    await openLink(HC_LINK);
    return 'loading';
  }
  if (availability === 'UpdateRequired') {
    showMessage('Health Connect is not installed. Please install it to continue.');
    return 'error';
  }
  return 'success';
};
